import Rest from '../rest'

/**
 * @type {Tokens}
 */
export default class Tokens extends Rest {

    constructor() {
        super('/tokens')
    }

    chat() {
        return this.getAll(
            'integration/chat', {}
        )
    }
}